import { skipToken } from '@reduxjs/toolkit/query'
import {
  selectFinancialYear,
  selectPartnerId,
  selectProgramType,
} from 'legacy/lut/features/partner360/configuration'
import { selectJBPSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { FormMultiselect } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations'
import { Static } from 'core-components/types'
import { Crud } from 'core/types'
import { TKeyInitiative, useGetKeyInitiativesQuery } from 'partner360/entities/keyInitiatives'
import { selectMdfActivities } from 'partner360/features/mdfActivities/model'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../../configs/translations'
import { filtersInitialData, MDF_DASHBOARD_FILTERS_FORM } from '../../../views/mdfDashboard/config'
import { getBusinessPrioritiesFromInitiatives } from '../../helpers/getBusinessPrioritiesFromInitiatives'

import styles from './MdfBusinessPrioritiesFilter.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS
const EMPTY_INITIATIVES: TKeyInitiative[] = []

export const MdfBusinessPrioritiesFilter = () => {
  const activities = useSelector(selectMdfActivities)
  const { kiBusinessPriorities } = useSelector(selectJBPSettings)
  const partnerId = useSelector(selectPartnerId)
  const fYear = useSelector(selectFinancialYear)
  const programType = useSelector(selectProgramType)

  const { data: initiatives = EMPTY_INITIATIVES } = useGetKeyInitiativesQuery(
    partnerId && fYear ? { partnerId, fYear, programType } : skipToken
  )

  const businessPrioritiesSource = useMemo(() => {
    const data = getBusinessPrioritiesFromInitiatives(activities, initiatives, kiBusinessPriorities)
    return new Crud({
      fetcher: new Static(data),
      keyField: 'key',
      defaultPaging: { page: 0, pageSize: data.length },
    })
  }, [activities, initiatives, kiBusinessPriorities])

  return (
    <div className={styles.field}>
      <Translation text={KEYS.dashboard.filters.businessPriority} />

      <FormMultiselect
        defaultValue={filtersInitialData.businessPriorities}
        field={'businessPriorities'}
        formKey={MDF_DASHBOARD_FILTERS_FORM}
        source={businessPrioritiesSource}
        caption={'label'}
        isStatic
      />
    </div>
  )
}
